import EllipsisText from '@cp/src/components/EllipsisText';
import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import { formatNumber, shortNumberNotation } from '@cp/src/utils/commonUtils';
import React from 'react';
import cx from 'classnames';
import { Placement } from '@floating-ui/dom';

interface ICellRendererShortNumber {
  value: number;
  lineClamp?: number;
  hiddenPadding?: number;
  significantDigits?: number;
  isCurrency?: boolean;
  ellipsisWrapperClass?: string;
  tooltipContentClass?: string;
  tooltipPlacement?: Placement;
}

const CellRendererShortNumber: React.FC<ICellRendererShortNumber> = props => {
  const {
    value,
    lineClamp = 1,
    hiddenPadding = 10,
    significantDigits = 1,
    isCurrency = false,
    ellipsisWrapperClass,
    tooltipContentClass,
    tooltipPlacement = 'top'
  } = props;

  if (!Number.isFinite(value)) {
    // eslint-disable-next-line no-console
    console.warn('CellRendererShortNumber: value is not a number', typeof value);
  }

  if (!value && value !== 0) {
    return (
      <EllipsisText ellipsisWrapperClass={ellipsisWrapperClass} text={'-'} lineClamp={lineClamp} />
    );
  }

  let shorthandNumber = value == 0 ? '0' : shortNumberNotation(value, significantDigits);

  let toolTipContent = formatNumber(value, true);

  if (String(value) === shorthandNumber) {
    if (isCurrency) {
      shorthandNumber = `₹${shorthandNumber}`;
    }
    return (
      <EllipsisText
        ellipsisWrapperClass={ellipsisWrapperClass}
        text={shorthandNumber ?? '-'}
        lineClamp={lineClamp}
      />
    );
  }

  if (isCurrency) {
    shorthandNumber = `₹${shorthandNumber}`;
    toolTipContent = `₹${toolTipContent}`;
  }

  return (
    <Tooltip
      placement={tooltipPlacement}
      hiddenPadding={hiddenPadding}
      hideStrategy="referenceHidden"
    >
      <TooltipTrigger tooltipTriggerClassName="tooltipTriggerWrapper">
        <EllipsisText
          ellipsisWrapperClass={ellipsisWrapperClass}
          text={shorthandNumber ?? '-'}
          lineClamp={lineClamp}
        />
      </TooltipTrigger>
      <TooltipContent className={cx('tooltipWrapper', tooltipContentClass)}>
        {toolTipContent}
      </TooltipContent>
    </Tooltip>
  );
};

export default CellRendererShortNumber;
